import React from "react";

const EnvelopeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M6.5547 8.1682C6.09517 7.86185 5.4743 7.98602 5.16795 8.44555C4.8616 8.90508 4.98577 9.52595 5.4453 9.8323L10.3359 13.0927C11.3436 13.7645 12.6564 13.7645 13.6641 13.0927L18.5547 9.8323C19.0142 9.52595 19.1384 8.90508 18.8321 8.44555C18.5257 7.98602 17.9048 7.86185 17.4453 8.1682L12.5547 11.4286C12.2188 11.6525 11.7812 11.6525 11.4453 11.4286L6.5547 8.1682Z"
        fill="#646F87"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6246 2.62796C12.5903 2.16828 11.4097 2.16829 10.3754 2.62796L4.37545 5.29462C2.93093 5.93663 2 7.36911 2 8.94987V16.0002C2 18.2094 3.79086 20.0002 6 20.0002H18C20.2091 20.0002 22 18.2094 22 16.0002V8.94987C22 7.36911 21.0691 5.93663 19.6246 5.29462L13.6246 2.62796ZM11.1877 4.45558C11.7049 4.22574 12.2951 4.22574 12.8123 4.45558L18.8123 7.12225C19.5345 7.44325 20 8.15949 20 8.94987V16.0002C20 17.1048 19.1046 18.0002 18 18.0002H6C4.89543 18.0002 4 17.1048 4 16.0002V8.94987C4 8.15949 4.46547 7.44325 5.18772 7.12225L11.1877 4.45558Z"
        fill="#646F87"
      />
    </svg>
  );
};

export default EnvelopeIcon;
